// Makes each papers table row navigate to its manage page on click, while
// leaving nested links (title, file download) working on their own.
function mountPapersTable(): void {
  document.querySelectorAll<HTMLElement>("[data-row-href]").forEach((row) => {
    const href = row.dataset.rowHref
    if (!href) return

    row.addEventListener("click", (event) => {
      // Let clicks on real links/buttons behave normally.
      if (event.target instanceof Element && event.target.closest("a, button")) {
        return
      }
      // Honor modifier clicks / middle-click as "open in new tab".
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
        window.open(href, "_blank")
        return
      }
      window.location.assign(href)
    })
  })
}

mountPapersTable()
